
/**
 * Identify if NODE_ENV is 'development'
 */
export function isEnvDevelop () {
  return process?.env?.NODE_ENV === 'development'
}
